// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.CreateEyeglassOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateEyeglassOrderRequest extends GandalfModelBase {

	@GandalfLabel('Eyeglass Prescription')
	@GandalfProperty({ designType: Number })
	eyeglassPrescriptionId!: number | null;

	@GandalfLabel('Order Processor')
	@GandalfProperty({ designType: Number })
	orderProcessorConfigId!: number | null;

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfLabel('Vendor')
	@GandalfProperty({ designType: Number })
	vendorId!: number | null;

}
